import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'

import {
  hasPermission, RoleEnum, RoleNameEnum 
} from '@/misc/permissions/permissionsHelper'

export function useIsAuthorized(
  permissions: RoleEnum[],
  currentRole: MaybeRefOrGetter<RoleNameEnum>
) {
  return computed(() => {
    const roleToCheck = toValue(currentRole)
    return permissions.some((permission) => hasPermission(permission, roleToCheck))
  })
}